import React, { Component } from 'react';
import {
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    // Table
} from 'reactstrap'
import { MDBDataTableV5 } from 'mdbreact';
import moment from 'moment';
import ChevronArrows from '../ui_commons/chevronArrows';

class Tabs extends Component {
    state = {
        modal: true,
        dataTable: {},
        showingTable: false
    }

    componentDidMount = async () => {
        // var tempServiceDate = {columns: [], rows: []}
        var columns = []
        var rows = []
        const serviceData = await this.props.setData()
        if(serviceData[0]) {
            for (let key of Object.keys(serviceData[0])) {
                if (key === 'GlobalID') {
                    columns.push({
                        label: 'Global ID',
                        field: key,
                        width: 300
                    })
                } else {
                    let tempKey = key.includes('_') ? key.split('_').join('') : key
                    columns.push({
                        label: tempKey.includes('ID') ? tempKey.split('ID')[0].replace(/([A-Z])/g, ' $1').trim() + ' ID' : tempKey.replace(/([A-Z])/g, ' $1').trim(),
                        field: key,
                        width: 200
                    })
                }
    
            }
            for(let data of serviceData){
                var dataTemp = data
                for (let keyData of Object.keys(serviceData[0])) {
                    if (typeof data[keyData] === 'string' && moment(data[keyData]).isValid()) {
                        dataTemp = {
                            ...dataTemp,
                            [keyData]: moment(data[keyData]).format('MM/DD/YYYY')
                        }
                    }
                }
                rows.push(dataTemp)
            }
        }
        this.setState({
            dataTable: {
                columns,
                rows
            }
        })
    }

    shouldComponentUpdate(nextProps){
        return nextProps.showingTable !== this.state.showingTable;
    }
    
    componentDidUpdate(props){
        // Desired operations: ex setting state
        this.setState({
            showingTable: props.showingTable
        })
    }

    render() {
        return (
            <div className="tabsClass" id="TabTable">
                <Nav tabs>
                    <NavItem className="activeTab2">
                        <NavLink
                            className="activeTab"
                            onClick={() => this.props.showTable()}
                        >
                            <div style={{display: "flex"}} className="activeTabDiv">
                                View Tabular Data
                                <ChevronArrows direction={this.state.showingTable ? "down" : "up"} />
                            </div>
                        </NavLink>
                    </NavItem>
                    {/* <NavItem>
                        <NavLink
                            className=""
                            onClick={function noRefCheck() { }}
                        >
                            More Tabs
                        </NavLink>
                    </NavItem> */}
                </Nav>
                <TabContent activeTab="1" className='tabContent'>
                    <TabPane tabId="1">
                        <div className='tableDiv'>
                            <Button color="primary" style={{position: "absolute", right: "3%"}} onClick={() => this.props.ShowFullscreen()}>Fullscreen</Button>
                            {this.state.dataTable.columns &&
                                <MDBDataTableV5
                                    hover
                                    className='dataTableCSS'
                                    responsiveSm={true}
                                    scrollX
                                    entriesOptions={[5, 20, 25]}
                                    entries={5}
                                    pagesAmount={4}
                                    data={this.state.dataTable}
                                    fullPagination
                                    searchTop 
                                    searchBottom={false}
                                />}
                        </div>
                        {/* <Table responsive className='tableStyle'>
                            <thead>
                                <tr>
                                    {this.props.serviceData.length !== 0 && Object.keys(this.props.serviceData[0]).map(x =>
                                        <th key={x}>{x}</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {this.props.serviceData.length !== 0 && this.props.serviceData.map(y => 
                                        Object.keys(this.props.serviceData[0]).map(x =>
                                            <td key={y[x]}>{y[x]}</td>
                                    ))}
                                </tr>
                            </tbody>
                        </Table> */}
                    </TabPane>

                </TabContent>
            </div>
        );
    }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/tabs/index.js